const webPExtension = (url) => {
  let paramChar = '?';

  if (url.indexOf('?') !== -1) {
    paramChar = '&';
  }

  return url + paramChar + 'fm=webp';
};

export function selectPreferredImage({ damImage, nonDamImage }) {
  let preferredImage;

  if (damImage?.damContentSelector) {
    preferredImage = damImage.damContentSelector.assetData?.[0]?.selectedImageUrl;
    return preferredImage;
  }

  if (damImage?.damDownloadedContent) {
    preferredImage = webPExtension(damImage.damDownloadedContent.url);
    return preferredImage;
  }

  if (nonDamImage) {
    preferredImage = webPExtension(nonDamImage.url);
  }

  return preferredImage;
}
